import React, { useContext } from "react";
import { HexpertContext } from "../../contexts/HexPertProvider";
import { PageQuestion } from "../../types/hexpertTypes";
import './ParagraphTextElementBlock.scss';

export const ParagraphTextElementBlock = ({ ParagraphText }: PageQuestion) => {
  const { state } = useContext(HexpertContext);
  return (
    <div className="c-hex-form-group-container">
      <div dangerouslySetInnerHTML={{ __html: ParagraphText }}></div>
      <p className="c-hex-paragraph-text-block-industry-type">
        {state.chosenIndustry?.Title}
      </p>
      <p className="c-hex-paragraph-text-block-industry-description">
        {state.chosenIndustry?.Description}
      </p>
    </div>
  );
};
